import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import AuthContext from "../../../context/UserSummary";
import axios from "../../../api/axios";
import { FaRegUser, FaKey, FaTimes } from "react-icons/fa";
import logoimg from "../../../images/logo.png";
import "./Login.css";
import SyncLoader from "react-spinners/SyncLoader";
const LOGIN_URL = "/api/login";

const Login = () => {
  const decor = {
    textDecoration: "none",
  };

  const { setAuth, setIsLoggedIn } = useContext(AuthContext);
  let navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    let config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        LOGIN_URL,
        {
          email: username,
          password,
        },
        config
      );
      console.log(JSON.stringify(response?.data));
      const accessToken = response?.data?.token_key;
      const roles = response?.data.roles;
      setAuth({ username, password, roles, accessToken });
      setIsLoggedIn(true);
      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("accessToken", accessToken);
      navigate("/");
    } catch (err) {
      if (!err.response) {
        setErrMsg("No server resonse");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or password");
      } else if (err.response?.status === 401) {
        setErrMsg("Invalid credentials. Please try again");
      } else {
        setErrMsg("Invalid credentials. Please try again.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="form-container">
      <div className="form-wrapper">
        <p className={errMsg ? "errmsg" : "offscreen"} arial-live="assertive">
          {errMsg}
        </p>
        <form onSubmit={(e) => handleSubmit(e)} className="login-form">
          <div className="login-cancel">
            <Link to="/" className="">
              <FaTimes className="login-cancel-icon" />
            </Link>
          </div>
          <Link to="/">
            <div className="login-img-div">
              <img className="logo-img" src={logoimg} alt="" />
            </div>
          </Link>
          <h3>Login</h3>
          <div className="login-info-wrap log">
            <label for="myfile" className="login-name">
              Email Address *
            </label>
            <div className="input-style">
              <div className="input-icon">
                <FaRegUser className="userprofile" />
              </div>
              <input
                type="text"
                id="username"
                onChange={(e) => setUsername(e.target.value)}
                value={username}
                required
                placeholder="Your Email"
              />
            </div>
            <div className="login-info-wrap ">
              <label for="myfile" className="login-name">
                Password *
              </label>
              <div className="input-style">
                <div className="input-icon">
                  <FaKey className="userprofile" />
                </div>
                <input
                  type="password"
                  id="password"
                  onChange={(e) => setPassword(e.target.value)}
                  value={password}
                  required
                  placeholder="Your Password"
                  autoComplete="current-password"
                />
              </div>
            </div>
          </div>
          {isLoading ? (
            <div className="loading">
              <SyncLoader color={"#098FD2"} loading={isLoading} size={10} />
            </div>
          ) : (
            <div className="login-btn">
              <button type="submit" className="login-button">
                Login
              </button>
            </div>
          )}
          <div className="exist-acc">
            <p>Don't have an account?</p>

            <Link style={decor} to="/register" className="reg-info">
              <li className="home reg"> Register</li>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
